import type { FaireProductEntity } from "../../entity_types/product";

export const p_m4rxmapvte: FaireProductEntity = {
  token: "p_m4rxmapvte",
  type: "product",
  name: "Spooky Snack Mix (Fall Seasonal)",
  brandToken: "b_jpp7njnwcc",
  brandName: "Tablespoon Cooking Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/a5a3f6cc2a148d4c82f75e8fda0a7985342936c5084eb0778d280f76decca934.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/db9c7aa31b4d33c95a23cd3b19302e4d1d341b8eb6adc7199ef4e07142c122dc.jpeg",
    "https://cdn.faire.com/fastly/f95f60843069f12e6753159740327b88bbb51c5ad2161abc6863ac3b01056b60.jpeg",
  ],
  priceDollars: 9.66,
  description:
    "Chocolatey | Festive | Fall Favorite\n\nGet into the Halloween spirit with our Spooky Snack Mix—a frightfully fun, super chocolatey blend packed with everyone’s favorite Halloween candies. Hand-crafted with high-quality ingredients, this seasonal mix is the perfect balance of nostalgic treats and irresistible flavor.\n\nOnly available in the fall, it’s a limited-edition crowd-pleaser ideal for parties, gifting, or festive retail displays. Don’t miss out—this mix disappears fast (just like the candy bowl)!\n\nKey Features:\n- Fall-only seasonal release\n- Loaded with classic Halloween candies\n- Rich, chocolatey flavor in every bite\n- Made with high-quality, hand-selected ingredients\n\nGreat for gifting, parties, and Halloween-themed displays\n\nLimited time. Maximum treat.",
  tags: [],
  msrpDollars: 19.32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:53:43.131Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
